import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
import { LanguageConstants } from '../constants/LanguageConstants';

/** Max length for contact message (standalone page shows count / this value). */
export const CONTACT_MESSAGE_MAX_CHAR = 500;

const emojiFreeRegex = /^[\w\s\.,'!&@()-áéíóúÁÉÍÓÚñÑ]+$/;


const contactUsValidation: any = yup.object().shape({
        name: yup.string().required(LanguageConstants?.PLEASE_ENTER_NAME)
        .min(3, LanguageConstants?.NAME_MIN)
        .max(25, LanguageConstants?.NAME_MAX)
        .matches(/^(?!.*\s{2,}).*$/, "name line cannot contain consecutive spaces")
        .matches(emojiFreeRegex, (LanguageConstants?.Emojis)),

        email: yup.string().required(LanguageConstants?.PLEASE_ENTER_Email)
        .email(LanguageConstants.EMAIL_ADDRESS)
        .matches(VALIDATION_MESSAGE.EMAIL_REGREX, LanguageConstants.EMAIL_ADDRESS)
        .max(150, LanguageConstants?.EMAIL_MAX)
        .trim(),

        subject: yup.string().required(VALIDATION_MESSAGE.Field("subject"))
        .min(3, VALIDATION_MESSAGE?.MinLength("subject ", 3))
        .max(25, VALIDATION_MESSAGE?.MaxLength("subject", 25))
        .matches(/^(?!.*\s{2,}).*$/, "subject line cannot contain consecutive spaces")
        .matches(emojiFreeRegex, ("Emojis not allowed")),

        description: yup.string().required(LanguageConstants?.ENTER_DESC)
        .min(3, LanguageConstants?.DES_MIN)
        .max(CONTACT_MESSAGE_MAX_CHAR, LanguageConstants?.CONTACT_DES_MAX)
        .matches(emojiFreeRegex, (LanguageConstants?.Emojis)),

});

export default contactUsValidation;

